import { IPlayForFunIndicatorState } from "@netent/playui";
import { FeatureStateCreator } from "../../types";

export const playForFunIndicatorState: FeatureStateCreator<IPlayForFunIndicatorState> = (): IPlayForFunIndicatorState => ({
  enabled: false
});
